export function getdata() {
	var obj = {
		headData: [{
				title: "业务类型",
				prop: "businessTypeName"
			},
			{
				title: "当前凭证数量",
				prop: "currVoucherCount",
				custom:true
			},
			{
				title: "当前凭证金额",
				prop: "currVoucherAmount",
				AmountFormat: true,
				custom:true
			},
			{
				title: "当前票据数量",
				prop: "currInvoiceCount",
				custom:true
				
			}, {
				title: "当前票据金额",
				prop: "currInvoiceAmount",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "当前票据税额",
				prop: "currInvoiceTax",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "税额差异",
				prop: "taxDiff",
				AmountFormat: true,
				custom:true
			}
		],
		outputData: {
			exportType: "",
			shenbq: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 50,
			paginationkey: 1
		},
		initdata:[
			{
				businessTypeName: "票账相符",
				currVoucherCount: "265",
				currVoucherAmount: "7579.47",
				currInvoiceCount: "265",
				currInvoiceAmount: "63455.99",
				currInvoiceTax: "7579.11",
				taxDiff: "420.44",
				type: "1"
			},
			{
				businessTypeName: "票账相符",
				currVoucherCount: "265",
				currVoucherAmount: "7579.47",
				currInvoiceCount: "265",
				currInvoiceAmount: "63455.99",
				currInvoiceTax: "7579.11",
				taxDiff: "420.44",
				type: "2"
			},
			{
				businessTypeName: "票账相符",
				currVoucherCount: "265",
				currVoucherAmount: "7579.47",
				currInvoiceCount: "265",
				currInvoiceAmount: "63455.99",
				currInvoiceTax: "7579.11",
				taxDiff: "420.44",
				type: "3"
			},
		]
	}
	return obj
}
